export const getLabelForAppIcon = (iconKey) => {
  const EXCEPTIONS_MAP = {
    Default: 'Other',
    Monashedu: 'Monash.edu',
  };
  return EXCEPTIONS_MAP[iconKey] ?? iconKey;
};

export const sortAppIconOptions = (a, b) => {
  const iconTextA = a.text;
  const iconTextB = b.text;

  // "Default" comes first
  const DEFAULT_KEY = 'Default';
  const defaultOptionText = getLabelForAppIcon(DEFAULT_KEY);

  if (iconTextA === defaultOptionText) return -1;
  if (iconTextB === defaultOptionText) return 1;

  // else, alphabetically sorted
  if (iconTextA < iconTextB) return -1;
  if (iconTextA > iconTextB) return 1;

  return 0;
};
